import React from 'react'
import PlanAccessMessages from '../PlanAccessMessages/index'

interface ModalPlanAccessProps {
  eligibility: Map<string, unknown>
  page: string
}

function ModalPlanAccess (props: ModalPlanAccessProps) {
  const { eligibility, page } = props

  return (
    <div className="modal-plan-access">
      <PlanAccessMessages eligibility={eligibility} page={page} />
    </div>
  )
}

export default ModalPlanAccess
